//
// DynamicRole.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./DynamicReferenceContainer";
import "./DynamicRoleType";
import "../DataProvider";
import "../../core/DataRendererModel";

var DynamicRole = createModule("gtl::DynamicRole", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::Dynamic","gtl::DynamicReferenceContainer"], EventDispatcher, [
    ,
    {
        dataField: [7],
        enablePatternMatching: 2,
        dataProvider: 1,
        assignedType: 4,
        type: 4,
        dataFieldDefault: [7],
        dataFieldMultiplesAllowed: 2,
    },
    ,
    ,
    {
        getAllReferencedDataRendererModels: [[1]],
        isDataFieldAddAllowed: [2],
    },
    {
        _create: [4],
    },
    ,
]);
export default DynamicRole;
